(function () {
    var bar = document.getElementById('sticky-atc-bar');
    if (!bar) return;

    var stickyBtn = document.getElementById('sticky-atc-btn');
    var priceEl = document.getElementById('sticky-atc-price');
    var sectionId = bar.getAttribute('data-section-id');
    var formId = 'product-form-' + sectionId;

    var mainForm = document.querySelector('form[data-type="add-to-cart-form"]')
        || document.querySelector('product-form form')
        || document.getElementById(formId);

    var mainBtn = mainForm
        ? (mainForm.querySelector('button[name="add"]') || mainForm.querySelector('.product-form__submit'))
        : null;

    // --- Price sync ---
    function updatePrice() {
        if (!priceEl) return;
        var priceItem = document.querySelector(
            '#price-' + sectionId + ' .price-item--regular, ' +
            '#price-' + sectionId + ' .price-item--sale'
        );
        if (priceItem) priceEl.textContent = priceItem.textContent.trim();
    }
    updatePrice();

    // --- Button state sync ---
    function syncState() {
        if (mainBtn && stickyBtn) {
            stickyBtn.disabled = mainBtn.disabled;
            stickyBtn.style.opacity = mainBtn.disabled ? '0.5' : '1';
            stickyBtn.style.cursor = mainBtn.disabled ? 'not-allowed' : 'pointer';
        }
        updatePrice();
    }
    syncState();
    if (mainBtn) new MutationObserver(syncState).observe(mainBtn, { attributes: true, childList: true, subtree: true });

    // --- Add to cart ---
    if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
            if (!mainBtn || mainBtn.disabled) return;

            // Trigger the native Shopify product-form button click. 
            // The theme's native JS will catch this, do the AJAX request, 
            // update the Cart Drawer (even if empty), and open it flawlessly.
            var originalText = stickyBtn.textContent;
            stickyBtn.disabled = true;
            stickyBtn.style.opacity = '0.6';
            stickyBtn.textContent = '...';

            mainBtn.click();

            // Re-enable sticky button shortly after execution
            setTimeout(function () {
                stickyBtn.disabled = false;
                stickyBtn.style.opacity = '1';
                stickyBtn.textContent = originalText;
            }, 800);
        });
    }

    // --- Show/hide ---
    var target = mainBtn || document.querySelector('.product-form__buttons') || document.querySelector('product-form');
    function isMobile() { return window.innerWidth < 750; }
    function checkVisibility() {
        if (!isMobile()) { bar.style.display = 'none'; return; }
        if (!target) { bar.style.display = 'flex'; bar.setAttribute('aria-hidden', 'false'); return; }
        var rect = target.getBoundingClientRect();
        var visible = rect.bottom > 0 && rect.top < window.innerHeight;
        bar.style.display = visible ? 'none' : 'flex';
        bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }
    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility, { passive: true });
    checkVisibility();

    var priceContainer = document.getElementById('price-' + sectionId);
    if (priceContainer) new MutationObserver(updatePrice).observe(priceContainer, { childList: true, subtree: true });
})();
